import React, {lazy, Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import Loader from '../Loader/Loader';

const LoginPage = lazy(() => import('../../pages/loginPage/LoginPage'));
const SSOLoginPage = lazy(() => import('../../pages/loginPage/SSOLoginPage'));
const HomePage = lazy(() => import('../../pages/homePage/HomePage'));
const ChangePasswordPage = lazy(() => import('../../pages/changePasswordPage/ChangePasswordPage'));
const AddUserPage = lazy(() => import('../../pages/addUserPage/AddUserPage'));
const RoleManagementPage = lazy(() => import('../../pages/roleMenagmentPage/RoleMenagmentPage'));
const SSOAuthCodeCallBackPage = lazy(() => import('../../pages/loginPage/SSOAuthCodeCallBackPage'));
const ForgotPasswordPage = lazy(() => import('../../pages/loginPage/ForgotPasswordPage'));

function AppRoute({user, isUserLoggedIn}) {
    return (
        <Suspense fallback={<Loader/>}>
            <Routes>
                {!user && <Route path="/login" element={<LoginPage/>}/>}
                {!user && <Route path="/login-sso" element={<SSOLoginPage/>}/>}
                {!user && <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>}
                <Route element={<ProtectedRoute isAllowed={isUserLoggedIn} isAuthenticated={isUserLoggedIn}/>}>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/password-change" element={<ChangePasswordPage/>}/>
                </Route>
                <Route element={<ProtectedRoute 
                    isAllowed={isUserLoggedIn && user?.roles?.includes('admin')} 
                    isAuthenticated={isUserLoggedIn}
                />}>
                    <Route path="/user-configuration" element={<AddUserPage/>}/>
                    <Route path="/role-management" element={<RoleManagementPage/>}/>
                </Route>
                <Route path="/sso-auth-callback" element={<SSOAuthCodeCallBackPage/>}/>
            </Routes>
        </Suspense>
    );
}

export default AppRoute;